import { Button } from '@/components/Button'
import { Input } from '@/components/Input'
import { Loader } from '@/components/Loader'
import { PasswordInput } from '@/shared/Auth/components/PasswordInput'
import { Row } from '@/shared/Auth/components/Row'
import { Title } from '@/shared/Auth/components/Title'
import { FC, FormEventHandler, useCallback } from 'react'
import styles from './PasswordReset.module.scss'

interface PasswordResetProps {
  className?: string
  isLoading: boolean
  newPassword: string
  retryNewPassword: string
  errors?: {
    newPassword?: string
    retryNewPassword?: string
  }
  setNewPassword: (value: string, name?: string) => void
  setRetryNewPassword: (value: string, name?: string) => void
  saveNewPassword: () => void
}
export const PasswordReset: FC<PasswordResetProps> = ({
  className,
  isLoading = false,
  newPassword,
  setNewPassword,
  retryNewPassword,
  setRetryNewPassword,
  saveNewPassword,
  errors = {},
}) => {
  const send: FormEventHandler = useCallback(
    (event) => {
      event?.preventDefault()
      if (saveNewPassword) {
        saveNewPassword()
      }
    },
    [saveNewPassword]
  )

  return (
    <form onSubmit={send} className={className}>
      <Title title="Введите новый пароль" />
      <Row>
        <PasswordInput
          value={newPassword}
          onChange={setNewPassword}
          name="newPassword"
          error={errors.newPassword}
          placeholder={'Новый пароль'}
        />
      </Row>
      <Row>
        <Input
          value={retryNewPassword}
          onChange={setRetryNewPassword}
          type="password"
          name="retryNewPassword"
          error={errors.retryNewPassword}
          placeholder={'Повторите новый пароль'}
        />
      </Row>
      <Row isAdditional>
        <Button className={styles.button} type="submit" disabled={isLoading}>
          Отправить
          {isLoading ? <Loader className={styles.loader} onTop /> : false}
        </Button>
      </Row>
    </form>
  )
}
